<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-layout" v-if="message">
        <div class="md-layout-item md-size-100"></div>
        <div class="md-layout-item md-size-100">
          <NotificationDetail :notification="message" >
            <div slot="breadcrumb" class="breadcrumbs">
              <router-link to="/member/inbox">
                <small>My Inbox</small>
              </router-link>
              <span class="spacer" />
              <small>
                <b>{{ message.template.title }}</b>
              </small>
            </div>
          </NotificationDetail>
        </div>
      </div>
      <div class="md-layout" v-else>
        <div class="md-layout-item">
          <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NotificationDetail from "@/components/NotificationDetail.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "NotificationDetails",
  props: {
    id: String
  },
  components: {
    NotificationDetail
  },
  data: function() {
    return {};
  },
  methods: {
    ...mapActions({
      getMessageById: "getMessageById"
    })
  },
  computed: {
    ...mapState({
      message: s => s.notification.message
    })
  },
  created: function() {
    this.getMessageById(this.id);
  }
};
</script>
<style>
.breadcrumbs a {
  color: white !important;
}
.breadcrumbs .spacer:before {
  content: " / ";
}
.breadcrumbs {
  margin-bottom: 7px;
}
</style>
